export function passwordRequirements(value) {
    const regex = RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[@_!#$%^&*()<>?/|}{~:])(?!.*[\\s]).{8,20}$')

    return regex.test(value)
}

export function twoDigitsAfterDecimal(value) {
    const regex = RegExp('^\\d+(\\.\\d{1,2})?$')

    return regex.test(value)
}

export function fourDigitsAfterDecimal(value) {
    const regex = RegExp('^\\d+(\\.\\d{1,4})?$')

    return regex.test(value)
}

export function twoDigitsAfterDecimalWithComma(value) {
    const regex = RegExp('^\\d+(\\,\\d{1,2})?$')

    return regex.test(value)
}

export function twoDigitsAfterDecimalWithCommaAndSpaces(value) {
    const valueWithRemovedSpaces = value.replace(/\s/g, '')
    const regex = RegExp('^\\d+(\\,\\d{1,2})?$')

    return regex.test(valueWithRemovedSpaces)
}

export function pdfFileName(value) {
    const regex = RegExp('^[a-zA-Z0-9_-]+.pdf$')

    return regex.test(value)
}

export function validRuleNameLength(value, maxLength = 80) {
    return value?.length <= maxLength
}

export function validRuleIllegalCharacters(value) {
    const regex = RegExp(/[/:'\\"?*<>|()[\]%$#^&@{}~]/)

    return regex.test(value)
}

export function validRuleIllegalCharactersJobName(value) {
    const regex = RegExp(/[/:'\\"?*<>|()[\]$#^&@{}~]/) // without '%'

    return regex.test(value)
}

export function isGreaterThanZero(value) {
    return Number(value.toString().replace(/[^0-9,-]+/g, '').replace(/[,]+/g, '.')).toFixed(2) > 0
}

export function isInteger(value) {
    return RegExp(/(^[0-9]*$)|(^-[0-9]+$)/).test(value)
}

export function digitsAndCharactersOnly(value) {
    const regex = RegExp('^[A-Za-z0-9]+$')

    return regex.test(value)
}
